import { z } from 'zod';

import { campaignTagsSchema } from './analytics/campaign-tags.js';

import type { Zot } from '@cadstrom/sigma-engine-shared';
import type { CampaignTags } from './analytics/campaign-tags.js';

/**
 * The shape of the `appState` object that we should pass to `auth0Client.loginWithRedirect()`. The app state is
 * retrieved in the Auth0 callback route that the user is sent back to after authentication.
 */
export interface Auth0AppState {
	/**
	 * The pathname to redirect the user to after authentication. If not provided, the user will be redirected to the root.
	 */
	returnTo?: string;
	/**
	 * Campaign tags from the link that began the login. Authenticating leaves the app entirely, so tags only reach the
	 * signup event if they travel here or are saved with the user by the login provider.
	 */
	campaign?: CampaignTags;
}

export const auth0AppStateSchema = z.object({
	returnTo: z.string().startsWith('/').optional(),
	// Malformed stored tags are dropped rather than failing the login they rode in on.
	campaign: campaignTagsSchema.optional().catch(undefined),
}) satisfies Zot<Auth0AppState>;
